
<div class="bodyWrapper p-0 mt-0 col-xs-12 col-sm-12">
  <div class="row">
    <div class="box-container p-0 mt-0 col-xs-12 col-sm-6">
      <a class="manage-quote-landing-page-menu-link" [routerLink]="['/manage-quote/kawneerdirect-quotes']">
        <div class="row">
          <div class="boxTitle">
            <h4>{{manageQuoteTxt.KDQuoteHeadingLbl?manageQuoteTxt.KDQuoteHeadingLbl: manageQuote.KDQuoteHeadingLbl}}</h4>
          </div><!--end title-->
        </div><!--end row-->
        <div class="boxBody">
          <div class="subText">
            <span>{{manageQuoteTxt.KDQuoteLbl1?manageQuoteTxt.KDQuoteLbl1:manageQuote.KDQuoteLbl1}}</span>
          </div><!--end subText-->
          <div class="boxImage">
            <img src="../../../../../assets/images/kawneerDirectQuotes.png" class="manage-quote-landing-page-menu-img" />
          </div><!--end boxImage-->

        </div><!--end boxBody-->
      </a>
    </div><!--end col-->
    <div class="box-container p-0 mt-0 col-xs-12 col-sm-6">
      <a class="manage-quote-landing-page-menu-link" [routerLink]="['/manage-quote/in-house-quote']">
        <div class="row">
          <div class="boxTitle">
            <h4>{{manageQuoteTxt.inHouseHeadingLbl?manageQuoteTxt.inHouseHeadingLbl:manageQuote.inHouseHeadingLbl}}</h4>
          </div><!--end title-->
        </div><!--end row-->
        <div class="boxBody">
          <div class="subText">
            <span>{{manageQuoteTxt.inHouseLbl1?manageQuoteTxt.inHouseLbl1:manageQuote.inHouseLbl1}}</span>
          </div><!--end subText-->
          <div class="boxImage">
            <img src="../../../../../assets/images/in-HouseQuotes.png" class="manage-quote-landing-page-menu-img" />
          </div><!--end boxImage-->
        </div><!--end boxBody-->
      </a>
    </div><!--end col-->
    <div class="box-container p-0 mt-0 col-xs-12 col-sm-6">
      <a class="manage-quote-landing-page-menu-link" [routerLink]="['/manage-quote/request-quote']">
        <div class="row">
          <div class="boxTitle">
            <h4>{{manageQuoteTxt.requestQuoteHeadingLbl?manageQuoteTxt.requestQuoteHeadingLbl:manageQuote.requestQuoteHeadingLbl}}</h4>
          </div><!--end title-->
        </div><!--end row-->
        <div class="boxBody">
          <div class="subText">
            <span>{{manageQuoteTxt.requestQuoteLbl1?manageQuoteTxt.requestQuoteLbl1:manageQuote.requestQuoteLbl1}}</span>
          </div><!--end subText-->
          <div class="boxImage">
            <img src="../../../../../assets/images/requestAQuote.png" class="manage-quote-landing-page-menu-img" />
          </div><!--end boxImage-->
        </div><!--end boxBody-->
      </a>
    </div><!--end col-->
    <div class="box-container p-0 mt-0 col-xs-12 col-sm-6">
      <a class="manage-quote-landing-page-menu-link" [routerLink]="['/manage-quote/factory-quote request']">
        <div class="row">
          <div class="boxTitle">
            <h4>{{manageQuoteTxt.factoryQuoteHeadingLbl?manageQuoteTxt.factoryQuoteHeadingLbl:manageQuote.factoryQuoteHeadingLbl}}</h4>
          </div><!--end title-->
        </div><!--end row-->
        <div class="boxBody">
          <div class="subText">
            <span>{{manageQuoteTxt.factoryQuoteLbl1?manageQuoteTxt.factoryQuoteLbl1:manageQuote.factoryQuoteLbl1}}</span>
          </div><!--end subText-->
          <div class="boxImage">
            <img src="../../../../../assets/images/factoryQuoteRequest.png" class="manage-quote-landing-page-menu-img" />
          </div><!--end boxImage-->
        </div><!--end boxBody-->
      </a>
    </div><!--end col-->
  </div>
</div>
